export default "https://housescan.app.solease.nl/static/media/floor_insulation_2.4c70827c.svg";